import { DOCS_URL } from "../../../config/constants.js";
import ServiceDivider from "./ServiceDivider.svelte";

export default {
    component: ServiceDivider,
    name: "Service Divider",
    description: "Horizontal separator for service page content flow.",
    docsLink: `${DOCS_URL}/storybook/?path=/story/molecules-servicedivider--default`,
    image: "https://unpkg.com/@tabler/icons@3.5.0/icons/outline/separator-horizontal.svg",
    models: ["service-page"],
    inputs: [],
};
